import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Globo from '@/views/Globo.vue'
import visualIdentityRoutes from './visualIdentityRoutes'
import verbalIdentityRoutes from './verbalIdentityRoutes'
import brandPlataformRoutes from './brandPlataformRoutes'
import UsefulFiles from '@/views/UsefulFiles.vue'
import Login from '@/views/Login/Login.vue'
import Logout from '@/views/Login/Logout.vue'
import store from '@/store'
import { applyHighlightAndWatch, clearPageHighlights } from '@/core/searchHighlight'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    meta: {
      hiddenOnNavigation: true
    },
    component: Home
  },
  {
    path: '/globo',
    name: 'globo',
    meta: {
      hiddenOnNavigation: true
    },
    component: Globo
  },
  visualIdentityRoutes,
  verbalIdentityRoutes,
  brandPlataformRoutes,
  {
    path: '/arquivos-uteis',
    name: 'arquivos-uteis',
    meta: {
      hiddenOnNavigation: true
    },
    component: UsefulFiles
  },

  //Login
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      labels: ['Login'],
      hiddenOnNavigation: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      hiddenOnNavigation: true
    }
  },

  //Admin
  {
    path: '/admin',
    name: 'admin',
    beforeEnter() {
      window.location.replace(`${process.env.VUE_APP_CENTRALDEMARCA_BACK_ADMIN}`)
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      scrollToHash(to.hash, (to.query.q as string) || '')
      return undefined
    }
    return { x: 0, y: 0 }
  }
})

const NAVBAR_HEIGHT = 80

function scrollToHash(hash: string, highlightQuery = ''): void {
  waitForElement(hash, 30000).then((found) => {
    if (!found) return
    const el = document.querySelector(hash) as HTMLElement | null
    if (!el) return

    waitForLayoutStable(800).then(() => {
      const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT
      window.scrollTo({ top, behavior: 'smooth' })
      if (highlightQuery) applyHighlightAndWatch(highlightQuery)
    })
  })
}

function waitForLayoutStable(stableMs = 800, safetyMs = 30000): Promise<void> {
  return new Promise((resolve) => {
    let timer: ReturnType<typeof window.setTimeout> | null = null
    let done = false

    const finish = () => {
      if (done) return
      done = true
      if (timer !== null) window.clearTimeout(timer)
      window.clearTimeout(safety)
      observer.disconnect()
      resolve()
    }

    const resetTimer = () => {
      if (done) return
      if (timer !== null) window.clearTimeout(timer)
      timer = window.setTimeout(finish, stableMs)
    }

    const safety = window.setTimeout(finish, safetyMs)
    const observer = new ResizeObserver(resetTimer)
    observer.observe(document.body)
    resetTimer()
  })
}

function waitForElement(selector: string, timeoutMs = 3000, intervalMs = 80): Promise<boolean> {
  return new Promise((resolve) => {
    const start = Date.now()
    const tick = () => {
      try {
        if (document.querySelector(selector)) {
          resolve(true)
          return
        }
      } catch {
        resolve(false)
        return
      }
      if (Date.now() - start >= timeoutMs) {
        resolve(false)
        return
      }
      window.setTimeout(tick, intervalMs)
    }
    tick()
  })
}

router.beforeEach(async (to, _, next) => {
  clearPageHighlights()
  const { isLogged } = store.state.login
  const isUnprotectedRoute = (name: string | null | undefined) => {
    if (name) return ['login', 'logout'].includes(name)
    return false
  }

  const unprotected = isUnprotectedRoute(to.name)

  if (unprotected) {
    next()
  } else {
    if (!isLogged) {
      next({ name: 'login' })
      return
    }

    next()
  }
})

export default router
